<template>
  <div class="flex justify-between items-center py-3 pl-3 pr-7 border-0 border-t border-solid border-soft cursor-pointer min-w-0"
       :class="{ 'bg-primary-light': isSelected || isHovered }"
       @mouseenter="$emit('mouseenter')"
       @mouseleave="$emit('mouseleave')"
  >
    <input-with-error-message v-if="isRenaming"
                              id="index-source-name-input"
                              :value.sync="localRenameValue"
                              :is-loading="isRenameLoading"
                              @escape="$emit('cancel-rename')"
                              @submit="$emit('submit-rename')"
                              class="w-full py-3"
                              :class="nameIndentClass"
    />
    <div v-else class="min-w-0 flex-1" @click="$emit('select')">
      <div class="grid grid-cols-10 min-w-0">
        <span class="col-span-8 text-black truncate pr-2" :class="nameIndentClass">{{ indexSource.name }}</span>
        <div class="col-span-2 text-gray flex justify-end items-center gap-2">
          <component
            :is="errorText ? 'vx-tooltip' : 'div'"
            :text="errorText"
            class="flex items-center gap-2"
          >
            <component :is="sourceIcon" class="text-gray"/>
            <span>{{ formatText }}</span>
            <span v-if="errorText">⚠️</span>
          </component>
        </div>
      </div>
    </div>
    <div class="w-12 flex-shrink-0 flex items-center justify-end">
      <side-list-menu v-if="!isRenaming"
                      :items="menuItems"
                      @rename="$emit('rename')"
                      @reindex-all-sources="$emit('reindex')"
                      @delete="$emit('delete')"
      />
    </div>
  </div>
</template>

<script>
import InputWithErrorMessage from '@/components/common/InputWithErrorMessage.vue'
import SideListMenu from '@/components/common/SideListMenu'
import ScrapeWebIcon from '@/assets/images/icons/ScrapeWebIcon'
import CodeFileIcon from '@/assets/images/icons/CodeFileIcon'
import FileIcon from '@/assets/images/icons/FileIcon'
import { MENU_ITEMS } from '@/utils/editor.constants'

export default {
  name: 'SettingsIndexesListSource',

  components: {
    InputWithErrorMessage,
    SideListMenu
  },

  props: {
    indexSource: {
      type: Object,
      required: true
    },
    index: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    isHovered: {
      type: Boolean,
      default: false
    },
    isRenaming: {
      type: Boolean,
      default: false
    },
    renameValue: {
      type: String,
      default: ''
    },
    isRenameLoading: {
      type: Boolean,
      default: false
    },
    nameIndentClass: {
      type: String,
      default: 'pl-8'
    }
  },

  computed: {
    localRenameValue: {
      get() {
        return this.renameValue
      },
      set(value) {
        this.$emit('update:renameValue', value)
      }
    },
    menuItems() {
      const menuItemReindex = { ...MENU_ITEMS.reindexAllSources, label: 'Reindex' }
      if (this.index.sources.length === 1) return [MENU_ITEMS.rename, menuItemReindex]

      const menuItemDelete = { ...MENU_ITEMS.delete, label: 'Delete source' }
      return [MENU_ITEMS.rename, menuItemReindex, menuItemDelete]
    },
    errorText() {
      return this.indexSource.config?.error
    },
    formatText() {
      const { format, type } = this.indexSource
      if (type === 'web_scraping') return 'Web Page'
      if (type === 'url') return format === 'xml' ? 'XML Feed' : 'JSON Feed'
      return format.toUpperCase() + ' File'
    },
    sourceIcon() {
      if (this.indexSource.type === 'file') return FileIcon
      if (this.indexSource.type === 'url') return CodeFileIcon
      return ScrapeWebIcon
    }
  }
}
</script>
